module.exports = __webpack_public_path__ + "img/393.e8204dcc.png";